const suppressedStrings = [
  "audience chattering",
  "audience laughs",
  "audience member mumbles",
  "audience member laughs",
  "bell",
  "buzzer",
  "blank_audio",
  "clap",
  "clicking",
  "clicks",
  "clears throat",
  "clippers buzzing",
  "cough",
  "coughing",
  "coughs",
  "crickets chirping",
  "crying",
  "inaudible",
  "indistinct",
  "keyboard clicking",
  "laughs",
  "mouse clicking",
  "murmuring",
  "music",
  "music playing",
  "pause",
  "phone ringing",
  "SCOFFS",
  "sighs",
  "speaking in foreign language",
  "sad music",
  "upbeat music",
  "whistling",
];

export const isSuppressedString = (input: string): boolean => {
  const trimmedInput = input.trim().toLowerCase();
  const regex = new RegExp(
    suppressedStrings
      .map((str) => `\\*\\*${str}\\*\\*|\\[${str}\\]|\\(${str}\\)`)
      .join("|"),
    "i"
  );

  return regex.test(trimmedInput);
};

export const dictationKeys = ["note", "macro", "diagnosis", "microscopic"];

export const findDictationKey = (input: string): string | undefined => {
  const trimmedInput = input.trim().toLowerCase();
  return dictationKeys.find((key) => trimmedInput.includes(key));
};
